export default __webpack_public_path__ + "static/media/maisVendasIcon.379c1745.svg";